import { faNewspaper } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Card, Badge, Row, Container } from 'react-bootstrap';
// import Markdown from 'react-markdown';
import Markdown from 'markdown-to-jsx'


const NewsCard = (props) => {
        return <>
        <Card className="shadow-lg" style={{ border: 'none', borderRadius: '12px',
            background: `
            linear-gradient(to right bottom, 
              rgba(26, 18, 31, 0.8),
              rgba(23, 19, 33, 0.8),
              rgba(18, 20, 35, 0.8),
              rgba(13, 22, 36, 0.8),
              rgba(6, 23, 37, 0.8)
            )
            `,
            color: '#d9d9d9',
            padding: '20px',
            borderRadius: '10px'
          }}
        >
        <Card.Header>
          <h6 style={{fontFamily: "Georgia, sans-serif"}}><FontAwesomeIcon icon={faNewspaper}  /> News</h6>
        </Card.Header>
              <Card.Body>
                <Card.Text>
                <Markdown
                  options={{
                    overrides: {
                      h3: {
                        props: {
                          style: {
                            fontSize: "1em",
                          },
                        },
                      },
                      h4: {
                        props: {
                          style: {
                            fontSize: "1em",
                          },
                        },
                      },
                      a: {
                        props: {
                          style: {
                            color: "#d9d9d9",
                          },
                        },
                      },
                      p: {
                        props: {
                          style: {
                            color: "#d9d9d9",
                            },
                            },
                      }
                    },
                  }}
                      // className={"react-mdn"}
                      // components={{
                      //   h1: "h5",
                      //   h2: "h6",
                      //   h3: "h6",
                      // }}
                    >
                    {props.news}
                    </Markdown>
                    </Card.Text>
              </Card.Body>
            </Card>
            <br />
      <Row>
        <Container>
          <Card.Text>
            <h6>Sources:</h6>
            <ol>
              {props.citations &&
                props.citations.map((c, i) => {
                  return (
                    <li key={i.toString()}>
                      <img
                        height="16"
                        width="16"
                        src={`http://www.google.com/s2/favicons?domain=${c}`}
                      />
                      <a
                        style={{
                          fontSize: "0.8em",
                          color: "#bfbfbd",
                          margin: "2px 2px",
                        }}
                        href={c}
                        target="_blank"
                      >
                        {c}
                      </a>
                      <br />
                    </li>
                  );
                })}
            </ol>
          </Card.Text>
        </Container>
      </Row>
            </>
};

export default NewsCard;